let mapContainer;

function renderGoogleMap() {
    mapContainer = document.getElementById('map');

    if (mapContainer) {
        init();
    }
}

function init() {
    const {
        lng,
        lat,
        zoom,
        ico,
        linkUrl,
        icoWidth,
        icoHeight,
    } = JSON.parse(mapContainer.getAttribute('data-settings'));

    const image = {
        url: ico,
        scaledSize: new google.maps.Size(icoWidth, icoHeight),
    };

    const styles = [
        {
            featureType: 'all',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    saturation: 36,
                },
                {
                    color: '#000000',
                },
                {
                    lightness: 40,
                },
            ],
        },
        {
            featureType: 'all',
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    color: '#000000',
                },
                {
                    lightness: 16,
                },
            ],
        },
        {
            featureType: 'all',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 20,
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 17,
                },
                {
                    weight: 1.2,
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 20,
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'labels.icon',
            stylers: [
                {
                    saturation: '-100',
                },
                {
                    lightness: '-54',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'all',
            stylers: [
                {
                    visibility: 'off',
                },
                {
                    lightness: '0',
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 21,
                },
            ],
        },
        {
            featureType: 'poi',
            elementType: 'labels.icon',
            stylers: [
                {
                    saturation: '-89',
                },
                {
                    lightness: '-55',
                },
            ],
        },
        {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 17,
                },
            ],
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 29,
                },
                {
                    weight: 0.2,
                },
            ],
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 18,
                },
            ],
        },
        {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 16,
                },
            ],
        },
        {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 19,
                },
            ],
        },
        {
            featureType: 'transit.station',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'on',
                },
                {
                    saturation: '-100',
                },
                {
                    lightness: '-51',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#000000',
                },
                {
                    lightness: 17,
                },
            ],
        },
    ];


    const myLatLng = { lat, lng };

    const map = new google.maps.Map(mapContainer, {
        center: myLatLng,
        zoom,
        styles,
    });

    const marker = new google.maps.Marker({
        position: myLatLng,
        map,
        icon: image,
    });

    if (linkUrl && linkUrl.length) {
        marker.addListener('click', () => {
            window.open(linkUrl, '_blank');
        });
    }
}

export default renderGoogleMap;
